<template>
    <FullFillBox
        :pageID="1005"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.add === 1){
                this.showAddButton = true
            }
            if(data.delete === 1){
                this.showDeleteButton = true
            }
        }"
    >
        <h4>{{ $t('inventory_stock_transfer_in') }}</h4>
        <hr>
        <div class="row">
            <div class="col-lg-2 col-form-label">
                {{ $t('common_row_selected') }}{{ selectedRowsNum }}
            </div>
            <div class="col-lg-6">
                <button class="btn btn-primary" @click="selectTableRowToggle">
                    {{ selectButtonText }}
                </button>
            </div>
            <div class="col-lg-4">
                <select class="form-select" v-model="groupBy" @change="tableGroupBy">
                    <option value="no">{{ $t('inventory_table_gp_no_gp') }}</option>
                    <option value="transKey">{{ $t('table_key') }}</option>
                    <option value="outCode">{{ $t('inventory_table_gp_outCode') }}</option>
                    <option value="fromLid">{{ $t('table_from_location') }}</option>
                    <option value="toLid">{{ $t('table_to_location') }}</option>
                </select>
            </div>
        </div>

        <hr>
        <div ref="tabulatorTableUse"></div>
        <hr>
        <div id="error_show" style="display: none">
            <div id="error_details"></div>
            <hr>
        </div>
        <div class="row" style="margin-bottom: 5px">
            <div class="col-md-6 py-2">
                <button class="btn btn-warning" style="width: 200px;"
                        v-if="showDeleteButton"
                        @click="uploadToBackend(0)">
                    {{ $t('common_reject') }}
                </button>
            </div>
            <div class="col-md-6 py-2">
                <button class="btn btn-primary" style="width: 200px;"
                        v-if="showAddButton"
                        @click="uploadToBackend(1)">
                    {{ $t('common_confirm') }}
                </button>
            </div>
        </div>
    </FullFillBox>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import {TabulatorFull as Tabulator} from "tabulator-tables";

export default {
    name: "InventoryTransferInView",
    components: {
        Multiselect,
        FullFillBox,
    },
    data() {
        return {
            permissionDetails: {},
            showAddButton: false,
            showDeleteButton: false,
            groupBy: 'no',
            selectedRowsNum: 0,
            selectAllFlag: true,
            selectButtonText: '',
        }
    },
    methods: {
        async uploadToBackend(flag){
            let transTempList = this.tabulator.getSelectedData().map(a => a.id)
            await this.$mainApi.post('api/inventory/transfer-in/', {
                "mode": flag,
                "listData": transTempList
            })
                .then(response => {
                    if(response.data.status === 80){
                        this.getBackend()
                        if(response.data.details.length > 0){
                            let data = response.data.details
                            document.getElementById('error_show').style.display = 'block'
                            let parent = document.getElementById('error_details')
                            parent.innerHTML = ""
                            for(let i=0;i<data.length;i++){
                                let subParent =
                                    "<div class='row' style='background-color: #d4d5e5;border: solid grey 1px;border-radius: 15px'>" +
                                    "<div class='col-md-4 col-form-label'>" + data[i]['transName'] + "</div>" +
                                    "<div class='col-md-8'>" +
                                    "<p>" + data[i]['outCode'] + "</p>" +
                                    "<p>" + data[i]['qty'] + "</p>" +
                                    "<p>" + data[i]['errors'] + "</p>" +
                                    "</div>" +
                                    "</div><br>"
                                parent.innerHTML += subParent
                            }
                        }
                    }
                })

        },
        tableGroupBy(){
            if(this.groupBy === "no"){
                this.tabulator.setGroupBy("")
                this.tabulator.setSort("transID", "desc");
            }else if(this.groupBy === "transKey"){
                this.tabulator.setGroupBy("transID")
                this.tabulator.setSort("transID", "desc");
            }else if(this.groupBy === "outCode"){
                this.tabulator.setGroupBy("outCode")
                this.tabulator.setSort("outCode", "asc");
            }else if(this.groupBy === "fromLid"){
                this.tabulator.setGroupBy("fromLid")
                this.tabulator.setSort("fromLid", "asc");
            }else if(this.groupBy === "toLid"){
                this.tabulator.setGroupBy("toLid")
                this.tabulator.setSort("toLid", "asc");
            }
            this.tabulator.redraw()
        },
        async getBackend(){
            this.$store.commit('setIsTopLoading', true)
            document.getElementById('error_show').style.display = 'none'
            await this.$mainApi.get('api/inventory/transfer-out/')
                .then(response => {
                    if(response.data.status === 80){
                        this.tabulator.setData(response.data.details)
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
        getHeaderMenu(){
            return this.$getHeaderMenu(this.tabulator)
        },
        getGroupHeader(value, count, data, group) {
            let totalQty = 0
            for( let i = 0; i<data.length; i++ ) {
                if(data[i].hasOwnProperty("qty") ) {
                    totalQty += parseFloat( data[i]['qty'] );
                }
            }
            let returnTitle = value + "&nbsp;&nbsp;&nbsp;" +
                "<span style='color:#d00; margin-left:10px;'>" + count + "&nbsp;"+this.$t('common_record')+"</span>" +
                "<span style='color:#002cdd; margin-left:10px;'>" + totalQty + "&nbsp;"+this.$t('common_qty')+"</span>"
            if(this.groupBy === "transKey"){
                let remarks = data[0]['transRemarks']? "(" + data[0]['transRemarks'] + ")" : ""
                returnTitle = data[0]['transName'] + "&nbsp;&nbsp;" + remarks + "&nbsp;&nbsp;&nbsp;" +
                    "<span style='color:#d00; margin-left:10px;'>" + count + "&nbsp;"+this.$t('common_record')+"</span>" +
                    "<span style='color:#002cdd; margin-left:10px;'>" + totalQty + "&nbsp;"+this.$t('common_qty')+"</span>"
            }
            if(this.groupBy === "fromLid"){
                returnTitle = data[0]['fromLoc'] + "&nbsp;&nbsp;&nbsp;" +
                    "<span style='color:#d00; margin-left:10px;'>" + count + "&nbsp;"+this.$t('common_record')+"</span>" +
                    "<span style='color:#002cdd; margin-left:10px;'>" + totalQty + "&nbsp;"+this.$t('common_qty')+"</span>"
            }
            if(this.groupBy === "toLid"){
                returnTitle = data[0]['toLoc'] + "&nbsp;&nbsp;&nbsp;" +
                    "<span style='color:#d00; margin-left:10px;'>" + count + "&nbsp;"+this.$t('common_record')+"</span>" +
                    "<span style='color:#002cdd; margin-left:10px;'>" + totalQty + "&nbsp;"+this.$t('common_qty')+"</span>"
            }
            return returnTitle
        },
        selectTableRowToggle(){
            if(this.selectAllFlag === false){
                // Need to Select All
                this.selectButtonText = this.$t('common_row_unselect_all')
                this.tabulator.selectRow()
            }else{
                // Need to Unselect All
                this.selectButtonText = this.$t('common_row_select_all')
                this.tabulator.deselectRow()
            }
            this.selectAllFlag = !this.selectAllFlag
        },
    },
    mounted(){
        document.title = this.$t('title') + ' | ' + this.$t('inventory_stock_transfer_in')

        this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
            placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
            data: [],
            columns: [
                {formatter:"rownum", responsive: 0, minWidth: 50, width: 50, headerMenu: this.getHeaderMenu,},
                {title: "id", field: 'id', visible: false, resizable: false, sorter: 'number', width: 10, responsive: 0,},
                {title: "transId", field: 'transID', visible: false, resizable: false, sorter: 'number', width: 10, responsive: 0,},
                {
                    title: this.$t('table_key'), field: 'transName', sorter: 'string', resizable: false,
                    responsive: 0, minWidth: 250, formatter: 'textarea',
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_create_date'), field: 'createDate', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 100,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_key_remarks'), field: 'transRemarks', sorter: 'string', resizable: false,
                    responsive: 1, width: 200, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_show_name'), field: 'show_name', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 100,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_outCode_short'), field: 'outCode', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 150,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_innerCode'), field: 'innerCode', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 150, visible: false,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('product_product_en'), field: 'name_en', sorter: 'string', resizable: true,
                    responsive: 1, minWidth: 250, width: 250,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_from_location'), field: 'fromLoc', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_to_location'), field: 'toLoc', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_qty'), field: 'qty', sorter: 'string', resizable: true,
                    responsive: 1, widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_ctn'), field: 'ctn', sorter: 'string', resizable: true,
                    responsive: 1,widthGrow: 1,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
                {
                    title: this.$t('table_remarks'), field: 'remarks', sorter: 'string', resizable: false,
                    responsive: 1, minWidth: 100, headerMenu: this.getHeaderMenu,
                    headerFilter: "input",
                    headerFilterParams: {
                        valuesLookup: true, sort: 'asc', clearable: true, autocomplete: true, listOnEmpty: true
                    },
                },
            ],
            reactiveData: true, //enable data reactivity
            maxHeight: '90vh',
            responsiveLayout: 'collapse',
            layout: "fitColumns",
            movableColumns: true,
            movableRows: false,
            groupHeader: this.getGroupHeader,
            selectable:true,
            selectableRangeMode:"click",
        })
        this.tabulator.on('rowSelectionChanged', (data, rows) => {
            this.selectedRowsNum = rows.length
        })
        this.selectTableRowToggle()
        this.getBackend()
    }
}
</script>

<style scoped>

</style>
